import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

export const DispatchOrderDialog = ({
  open, onOpenChange, selectedOrder, dispatchRemaining,
  transporters, dispatchTransporterId, setDispatchTransporterId,
  selectedTransporter,
  vehicleNumber, setVehicleNumber, driverMobile, setDriverMobile,
  onDispatch,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent data-testid="dispatch-order-dialog" className="max-w-lg">
      <DialogHeader>
        <DialogTitle>
          Dispatch Order - #{selectedOrder?.id?.slice(0, 8)}
          {selectedOrder?.status === 'partial_dispatched' && <span className="ml-2 text-xs font-normal px-2 py-0.5 rounded" style={{ background: '#C05C35', color: 'white' }}>PARTIAL</span>}
        </DialogTitle>
      </DialogHeader>
      <form onSubmit={(e) => { e.preventDefault(); onDispatch(); }}>
      <div className="space-y-4">
        {dispatchRemaining && dispatchRemaining.items && (
          <div className="text-xs p-2 rounded" style={{ background: '#FBF9F6', color: '#5C6B61' }}>
            Dispatching all remaining bags: {dispatchRemaining.items.filter(i => i.remaining > 0).map(i => `${i.product_name}×${i.remaining}`).join(', ') || '(nothing)'}
            <div className="mt-1 text-[11px]">Facility split will be captured at delivery confirmation.</div>
          </div>
        )}
        <div>
          <label className="text-sm font-medium">Transporter</label>
          <select
            value={dispatchTransporterId}
            onChange={(e) => { setDispatchTransporterId(e.target.value); setVehicleNumber(''); setDriverMobile(''); }}
            className="w-full px-3 py-2 border rounded text-sm h-10"
            style={{ borderColor: '#E2DFD8' }}
            data-testid="dispatch-transporter-select"
          >
            <option value="">-- Select transporter (optional) --</option>
            {transporters.map((t) => (
              <option key={t.id} value={t.id}>{t.name}</option>
            ))}
          </select>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="text-sm font-medium">Vehicle Number</label>
            {selectedTransporter && (selectedTransporter.vehicles || []).length > 0 ? (
              <select value={vehicleNumber} onChange={(e) => setVehicleNumber(e.target.value)} className="w-full px-3 py-2 border rounded text-sm h-10" style={{ borderColor: '#E2DFD8' }} data-testid="vehicle-number-select">
                <option value="">-- Select vehicle --</option>
                {selectedTransporter.vehicles.map((v) => (<option key={v.id} value={v.number}>{v.number}</option>))}
              </select>
            ) : (
              <Input value={vehicleNumber} onChange={(e) => setVehicleNumber(e.target.value)} required placeholder="RJ01AB1234" data-testid="vehicle-number-input" />
            )}
          </div>
          <div>
            <label className="text-sm font-medium">Driver Mobile</label>
            {selectedTransporter && (selectedTransporter.drivers || []).length > 0 ? (
              <select value={driverMobile} onChange={(e) => setDriverMobile(e.target.value)} className="w-full px-3 py-2 border rounded text-sm h-10" style={{ borderColor: '#E2DFD8' }} data-testid="driver-mobile-select">
                <option value="">-- Select driver --</option>
                {selectedTransporter.drivers.map((d) => (<option key={d.id} value={d.phone}>{d.name} — {d.phone}</option>))}
              </select>
            ) : (
              <Input value={driverMobile} onChange={(e) => setDriverMobile(e.target.value)} required placeholder="+91XXXXXXXXXX" data-testid="driver-mobile-input" />
            )}
          </div>
        </div>
      </div>
      <DialogFooter className="mt-6">
        <Button type="submit" style={{ background: '#C05C35' }} data-testid="submit-dispatch-btn">
          Dispatch
        </Button>
      </DialogFooter>
      </form>
    </DialogContent>
  </Dialog>
);
